module.exports = __webpack_public_path__ + "static/img/xitongkuangjia (2).078ba5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/xitongkuangjia (2).png
// module id = sYsM
// module chunks = 1